import type { CompetitorRecord } from "@/lib/compare/types";

const HOME = "https://autoshorts.ai";
const FAQ = "https://autoshorts.ai/faq";
const PRICES_CHECKED = "2026-10-09";
const FAQ_CHECKED = "2026-10-08";

export const AUTOSHORTS: CompetitorRecord = {
  slug: "autoshorts",
  name: "AutoShorts",
  aliases: ["AutoShorts.ai", "Auto Shorts", "autoshorts.ai"],
  url: HOME,
  pricingUrl: HOME,
  category: "faceless",
  positioning: "Faceless videos on auto-pilot: a series that writes, renders and posts itself on a schedule.",
  plans: [
    {
      name: "Free",
      monthly: 0,
      metered: "Creates 1 video, 1 series, 0 motion credits",
      includes: [
        "Marked Temporarily paused on the pricing card",
        "FAQ: suspended due to abuse from botting / spamming",
        "1 series",
        "0 motion credits",
      ],
      sourceUrl: HOME,
      checkedAt: PRICES_CHECKED,
      note: "Listed on the homepage but not available to new signups as of Oct 9, 2026.",
    },
    {
      name: "Starter",
      monthly: 19,
      annualPerMonth: 16,
      metered: "Posts 3 times a week, 1 series, 27 motion credits per cycle",
      includes: [
        "1 series",
        "About 13 videos a month at 3 posts a week",
        "27 motion credits per cycle",
        "Auto-post to TikTok, YouTube and Instagram",
        "Voice cloning",
        "HD video resolution",
      ],
      sourceUrl: HOME,
      checkedAt: PRICES_CHECKED,
    },
    {
      name: "Daily",
      monthly: 39,
      annualPerMonth: 33,
      metered: "Posts once a day, 1 series, 62 motion credits per cycle",
      includes: [
        "1 series",
        "About 30 videos a month at 1 post a day",
        "62 motion credits per cycle",
        "Auto-post to TikTok, YouTube and Instagram",
        "Voice cloning",
      ],
      sourceUrl: HOME,
      checkedAt: PRICES_CHECKED,
    },
    {
      name: "Hardcore",
      monthly: 69,
      annualPerMonth: 58,
      metered: "Posts twice a day, 1 series, 124 motion credits per cycle",
      includes: [
        "1 series",
        "About 60 videos a month at 2 posts a day",
        "124 motion credits per cycle",
        "Auto-post to TikTok, YouTube and Instagram",
        "Voice cloning",
      ],
      sourceUrl: HOME,
      checkedAt: PRICES_CHECKED,
    },
  ],
  entryPlanName: "Starter",
  entryPlanIncludes: "One series that posts 3 times a week, about 13 videos a month, with 27 motion credits",
  freeTier: "Listed at $0 for 1 video and 1 series but marked Temporarily paused; the FAQ says it is suspended",
  trial: "None on the site",
  meteringUnit: "Posting cadence per series (3 a week, 1 a day, 2 a day), 1 series per plan",
  exportResolution: "HD video resolution on every plan; no 1080p or 4K figure published",
  features: {
    longToShort: { v: "no", note: "No upload-and-clip product" },
    momentRanking: { v: "no" },
    reframing: { v: "no", note: "Generates from scratch" },
    maxSource: { v: "text", note: "No source upload; scripts up to 1,600 characters" },
    layouts: { v: "n/a", note: "Art styles instead of layouts" },
    redditStory: { v: "partial", note: "Topic series only, no Reddit import" },
    fakeText: { v: "no" },
    aiImages: { v: "yes", note: "Per-scene images in about 17 art styles" },
    voiceover: { v: "yes", note: "Engine not disclosed" },
    voiceCloning: { v: "yes", note: "On every plan card" },
    avatars: { v: "n/a", note: "Not on the site" },
    timelineEditor: { v: "no", note: "Script, title, images, music swap only" },
    captionStyles: { v: "n/a", note: "Styles not enumerated" },
    captionLanguages: { v: "text", note: "30 languages" },
    bRoll: { v: "no", note: "AI images only, no stock library" },
    fourK: { v: "n/a", note: "HD only, no resolution figure" },
    scheduling: { v: "yes", note: "TikTok, YouTube, Instagram" },
    analytics: { v: "no" },
    socialTracker: { v: "no" },
    api: { v: "no", note: "None published" },
    webhooks: { v: "n/a", note: "Not on the site" },
    web: { v: "yes" },
    desktop: { v: "no", note: "Not advertised" },
    mobile: { v: "no", note: "Not advertised" },
    teamSeats: { v: "no", note: "One series per account" },
    freeTier: { v: "partial", note: "Listed, marked Temporarily paused" },
    trial: { v: "no", note: "None on the site" },
    metering: { v: "text", note: "Posting cadence per series" },
    rollover: { v: "partial", note: "Top-off credits never expire; plan credits reset" },
    refunds: { v: "text", note: "No refunds, per the FAQ" },
    cancelInApp: { v: "yes", note: "From the billing page" },
  },
  billingTerms: {
    refunds:
      'No refunds. The FAQ says "we cannot offer refunds as costs incurred for creating AI videos... are extremely high" and that "During sign up you agree to withhold your right to refund."',
    cancel: "One click from the billing page, per the FAQ.",
    sourceUrl: FAQ,
    checkedAt: FAQ_CHECKED,
  },
  quotes: [],
  theirCrayoPages: [
    {
      url: "https://autoshorts.ai/alternative/crayo-ai",
      date: "2025-11-12",
      claims: [
        "Hobby Plan: At $19 per month, it includes 40 minutes of video export",
        "Clipper Plan: At $39 per month, it provides 2 hours of video export with 30 avatar minutes",
        "Pro Plan: At $79 per month, it offers 3 hours of video export and 500 AI images",
        "Crayo AI focuses on video creation rather than distribution",
        "AutoShorts.ai offers deeper customization options, including art style selection and advanced voice models",
        "Page CTA reads Try AutoShorts.ai for Free (No credit card required) while the homepage marks the free plan Temporarily paused",
      ],
    },
  ],
  verification: {
    method: "browser",
    date: PRICES_CHECKED,
    note: "Read in a real browser on Oct 9, 2026 because the site renders client-side; the yearly toggle is labelled 2 MONTHS FREE. Monthly and yearly per-month figures for Starter, Daily and Hardcore come from that session. Yearly totals are not printed on the cards and are omitted. FAQ facts (refunds, cancellation, one series, 30 languages, 90-second cap, paused free plan) were read from autoshorts.ai/faq on Oct 8, 2026.",
  },
  seoPattern: "autoshorts.ai/alternative/<competitor-slug>, including a page about Crayo",
};
